// promos types
export default {
  STORE_PROMO_CODE: 'STORE_PROMO_CODE',
};
